"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var text_1 = require("./text");
Object.defineProperty(exports, "Text", { enumerable: true, get: function () { return text_1.Text; } });
//# sourceMappingURL=index.js.map